import { getRoleDisplayName, getRoleStyle } from "@dashone/user-scopes";

/**
 * Role utilities for User Scope Management. The role display vocabulary (names +
 * pill styles) is the shared canonical source in `@dashone/user-scopes`; the
 * helpers below layer admin-specific invite/scope logic on top of it.
 */

// Re-export the shared display helpers so existing importers of `../roleUtils`
// keep resolving them from a single place.
export { getRoleDisplayName, getRoleStyle };

/**
 * Roles that receive full workspace access automatically and therefore do not
 * require explicit market/execution scopes at invite time. Mirrors the backend
 * exemption in invite_user_with_temp_password.
 */
export const FULL_ACCESS_ROLES = ['super_admin'];

/**
 * Whether a workspace assignment carries the market scopes the backend
 * requires. Non-full-access roles must grant at least one market on at least
 * one product; without one, the backend stores product_scopes: null and every
 * scoped endpoint (e.g. /metrics/v2) 403s on dashboard load for the invited
 * user. Per-product model.
 *
 * @param {{role: string, product_scopes?: Record<string, string[]>}} assignment
 * @returns {boolean}
 */
export const hasRequiredScopes = ({ role, product_scopes } = {}) => {
  if (FULL_ACCESS_ROLES.includes(role)) return true;
  if (!product_scopes) return false;
  return Object.values(product_scopes).some((markets) => (markets?.length ?? 0) > 0);
};
